import React, { useEffect, useState } from 'react';
import { CustumerEnum } from '../../enum/CustumerEnum.ts';
import DefaultPropertyTypeUseCase from './DefaultPropertyTypeUseCase.ts'
import SmartmlsPropertyTypeUseCase from './SmartmlsPropertyTypeUseCase.ts'


let propertyTypeUseCase
const customer = process.env.REACT_APP_CUSTOMER
switch(customer) {
  case CustumerEnum.SMARTMLS:
    propertyTypeUseCase = new SmartmlsPropertyTypeUseCase()
    break;
  default:
    propertyTypeUseCase = new DefaultPropertyTypeUseCase()
    break
}

function PropertyTypeLabel(props) {
  const { propertyTypeDescription, propertySubTypeDescription } = props
  const [propertyTypeValue, setPropertyTypeValue] = useState(propertyTypeDescription)
  const [propertySupTypeValue, setPropertySubTypeValue] = useState(propertySubTypeDescription)

  useEffect(() => {
    const newPropertyTypeValue = propertyTypeUseCase.getPropertyType(propertyTypeDescription, propertySubTypeDescription)
    const newPropertySubTypeValue = propertyTypeUseCase.getPropertySubType(undefined, propertySubTypeDescription)
    setPropertyTypeValue(newPropertyTypeValue)
    setPropertySubTypeValue(newPropertySubTypeValue)
    
  }, [propertyTypeDescription, propertySubTypeDescription])

  return (
    <div className="property-type">
      {propertyTypeValue}{!!propertyTypeValue && !!propertySupTypeValue ? " - " : ""}{propertySupTypeValue}
    </div>
  );
}

export default PropertyTypeLabel;